import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
import EventsTable from "./BundleDetail/EventsTable";
import { KYDAdminEventSummary } from "@common/interfaces/KYDEvent";
import { KYDAdminFeedItem } from "@common/interfaces/KYDOrganization";
interface UpdateBundleEventsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  eventsInBundle: KYDAdminEventSummary[];
  events: KYDAdminEventSummary[];
  externalEvents: KYDAdminFeedItem[];
  isLastPage: boolean;
  showMore: () => void;
  onUpdateOrder: (order: string[]) => Promise<void>;
  onUpdateBundle: ({ events }: { events: string[] }) => Promise<void>;
}

export const UpdateBundleEventsDialog: React.FC<
  UpdateBundleEventsDialogProps
> = ({
  isOpen,
  onClose,
  eventsInBundle,
  events,
  externalEvents,
  isLastPage,
  showMore,
  onUpdateBundle,
}) => {
  const [previewEvents, setPreviewEvents] = useState<KYDAdminEventSummary[]>([
    ...eventsInBundle,
  ]);

  useEffect(() => { 
    setPreviewEvents([...eventsInBundle]);
  }, [eventsInBundle]);

  const onSave = async () => {
    await onUpdateBundle({ events: previewEvents.map((e) => e.id) });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxW="90vw">
        <ModalHeader>Edit Bundle Events</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <EventsTable
            selected={previewEvents.map((e) => e.id)}
            onAdd={async (event, type) => {
              setPreviewEvents((items) =>
                items.concat(event as KYDAdminEventSummary)
              );
            }}
            onRemove={async (event, type) => {
              setPreviewEvents((items) =>
                items.filter((e) => e.id !== event.id)
              );
            }}
            events={events}
            external={externalEvents}
            isLastPage={isLastPage}
            showMore={showMore}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={onClose}
            variant="outline"
            color="black"
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={onSave}
            backgroundColor="black"
            color="white"
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
